import { Typography, Card, Stack } from '@mui/material';
import { Link } from 'react-router-dom';

import { AddIcon, Button } from '@occc/ui-design-system';
import { Page } from '@occc-app/design-system';
import { Can } from '@occc-app/App/PolicyBasedAccessControl';
import { CreateRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';

import { routeCreator } from '../retailer-connect.utils';
import { useBreadcrumbLinks } from '../hooks/use-breadcrumb-links.hook';

const PAGE_TITLE = 'No networks found';

const RetailerNetworkNoNetworksPage = () => {
  useBreadcrumbLinks();

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: 'My Networks',
        titleTestId: 'rc-no-networks-title',
        subtitle: 'You currently manage 0 networks',
      }}
      containerProps={{ variant: 'md' }}
      actions={
        <Can I={CreateRetailerNetwork()}>
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            startIcon={<AddIcon />}
            to={routeCreator.configurationNetworkDetails}
            role='button'
          >
            Add New Network
          </Button>
        </Can>
      }
    >
      <Card sx={{ px: 3, py: 16 }}>
        <Typography variant='h5' align='center'>
          No networks found
        </Typography>
        <Can
          I={CreateRetailerNetwork()}
          fallback={
            <Typography variant='body2' align='center' mt={2}>
              A network must be set up before you can access Retailer Connect. <br />
              Please contact your account owner for assistance.
            </Typography>
          }
        >
          <Stack mt={2} gap={2} alignItems={'center'}>
            <Typography variant='body2' align='center'>
              To get started, add your first network
            </Typography>
            <Button
              variant='contained'
              component={Link}
              startIcon={<AddIcon />}
              to={routeCreator.configurationNetworkDetails}
              role='button'
            >
              Add New Network
            </Button>
          </Stack>
        </Can>
      </Card>
    </Page>
  );
};

export default RetailerNetworkNoNetworksPage;
